enum HealthPictureTypes {
  PaymentReceipt,
  Invoice,
  Invoices,
  InvoicesDetail,
  MedicalHistory,
  SurgicalNote,
  MedicalIndication,
  MedicalReport,
  MedicalNotes,
  Others,
}

export default HealthPictureTypes;
